import { apiInterfaceForJson } from "../common/apiManager";

export const fetchCalendarEvents = (params = {}) => {
    const qs = new URLSearchParams();
    if (params.from) qs.append("from", params.from);
    if (params.to) qs.append("to", params.to);
    if (params.status) qs.append("status", params.status);
    if (params.ownerId) qs.append("ownerId", params.ownerId);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return apiInterfaceForJson(`/calendar-event/v1/${suffix}`, "GET");
};

export const createCalendarEvent = (payload) => {
    return apiInterfaceForJson("/calendar-event/v1/", "POST", payload);
};

export const updateCalendarEvent = (id, payload) => {
    return apiInterfaceForJson(`/calendar-event/v1/${id}`, "PUT", payload);
};

export const deleteCalendarEvent = (id) => {
    return apiInterfaceForJson(`/calendar-event/v1/${id}`, "DELETE");
};

export const getCalendarEvent = (id) => {
    return apiInterfaceForJson(`/calendar-event/v1/${id}`, "GET");
};

export const fetchUpcomingCallbacks = (limit = 5) => {
    return apiInterfaceForJson(`/calendar-event/v1/upcoming?limit=${limit}`, "GET");
};
